import { render, staticRenderFns } from "./payfor-add.vue?vue&type=template&id=22b41b61&scoped=true&"
import script from "./payfor-add.vue?vue&type=script&lang=js&"
export * from "./payfor-add.vue?vue&type=script&lang=js&"
import style0 from "./payfor-add.vue?vue&type=style&index=0&id=22b41b61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b41b61",
  null
  
)

export default component.exports